import React, { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router'
import Navbar from './Navbar'
import Sidebar from './Sidebar'
import { useSelector } from 'react-redux'

function Layout() {
    // Récupérer l'URL actuelle
    const location = useLocation()
    //console.log(location.pathname)    

    useEffect(() => {
        // Enlever la class active de tous les a du Header
        document.getElementsByClassName('active').item(0).classList.remove('active')
        // Parcourir tous les a et trouver le lien avec le href correspondant au location actuel
        document.querySelectorAll('a').forEach(link => {
            if (link.getAttribute('href') === location.pathname) {
                link.classList.add('active')
            }
        })

    }, [location])    

    return (
        <>
            {/* strat navbar */}
            <Navbar />
            {/* end navbar */}

            {/* strat wrapper */}
            <div className="flex flex-row flex-wrap h-screen" id='wrapper'>

                {/* start sidebar */}
                <Sidebar />
                {/* end sidbar */}

                {/* strat content */}
                <div className="flex-1 bg-gray-100 md:mt-16 p-6">

                    <Outlet />

                </div>
                {/* end content */}
            </div>

        </>

    )
}

export default Layout